import { useEffect, useState } from "react";
import { useAsync } from "./asyncFunc";
import { Fetch } from "./misc";
import { useInterval } from "./useInterval";

const getVersion = async () => {
  return await Fetch(`${window.location.origin}/api/version`, {
    headers: {
      Accept: "*/*"
    }
  })
    .then((res) => {
      if (res.headers.get("Content-Type")?.includes("application/json")) {
        const response = res.json() as Promise<{
          success: true;
          version: string;
        }>;
        return response;
      } else {
        throw "Response is not in JSON format";
      }
    })
    .catch((err) => {
      throw err;
    });
};

const useVersion = () => {
  const version = process.env.REACT_APP_CURRENT_GIT_SHA;
  const versionLocal = sessionStorage.getItem("dyanamic_version") || null;
  const [count, setCount] = useState(0);

  const time = 1000 * 60 * 10;

  useInterval(
    {
      func: () => {
        setCount(count + 1);
      },
      time,
      call: true
    },
    [count]
  );

  const versionRes = useAsync(
    {
      asyncFunc: getVersion,
      funcParams: undefined as never,
      immediate: true,
      clearOnError: true
    },
    [count]
  );

  useEffect(() => {
    if (versionRes.called) {
      const vv = versionRes.data?.version || null;

      if (vv !== version) {
        sessionStorage.setItem("dyanamic_version", vv || "");
        if (vv != versionLocal) {
          // @ts-ignore
          window.location.reload(true);
        }
      }
    }
  }, [versionRes.data]);

  useEffect(() => {
    if (versionRes.error) {
      // console.log(versionRes.error);
    }
  }, [versionRes.error]);
};

export default useVersion;
